import { useParams } from 'react-router-dom';

import { TreatmentPlanV3PageContent, TreatmentPlanV3PageLoadState } from '../components';
import { MedicalPageContent } from './components';
import { useFetchTreatmentPlanV3MedicalPage, useTreatmentPlanV3MedicalPageState } from './hooks';

export default function MedicalForm() {
  const { treatmentPlanId } = useParams<'treatmentPlanId'>();
  const { retry } = useFetchTreatmentPlanV3MedicalPage();
  const { page, isLoading, hasLoaded, hasLoadError } = useTreatmentPlanV3MedicalPageState();

  return (
    <TreatmentPlanV3PageContent title="Medical">
      <TreatmentPlanV3PageLoadState
        errorMessage="Unable to load medical information. Please try again."
        hasLoaded={hasLoaded}
        hasLoadError={hasLoadError}
        onRetry={retry}
      >
        {page ? (
          <MedicalPageContent key={treatmentPlanId} disabled={isLoading} page={page} />
        ) : null}
      </TreatmentPlanV3PageLoadState>
    </TreatmentPlanV3PageContent>
  );
}
